import { render, staticRenderFns } from "./luckDraw.vue?vue&type=template&id=665c1081&scoped=true"
import script from "./luckDraw.vue?vue&type=script&lang=js"
export * from "./luckDraw.vue?vue&type=script&lang=js"
import style0 from "./luckDraw.vue?vue&type=style&index=0&id=665c1081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c1081",
  null
  
)

export default component.exports